import { Component, OnInit } from '@angular/core';
import { BaryModalEvent, IBaryModalEvent } from '../../../../../models/bary-modal-event';
import { BaryComponentHelper } from '../../../../shared/util/bary-component-helper';
import { MDBModalRef } from 'ng-uikit-pro-standard';
import { EstimationStatus, LastEstimate } from '../../../../../models/estimate-result-bundle.model';
import { EstimateService } from '../../../../../services/estimate.service';
import { QuotationView } from '../../../../../models/quotation-view.model';
import dayjs from 'dayjs';

@Component({
  selector: 'jhi-bary-modal-customer-respond-quotation',
  templateUrl: './bary-modal-customer-respond-quotation.component.html',
})
export class BaryModalCustomerRespondQuotationComponent implements OnInit {
  quotation!: QuotationView;
  action = BaryComponentHelper.generateAction<IBaryModalEvent>();
  loaded = false;
  estimation?: LastEstimate;

  constructor(private modalRef: MDBModalRef, private estimateService: EstimateService) {}

  ngOnInit(): void {
    this.estimateService.refreshPricing(this.quotation).subscribe(estimation => {
      this.estimation = estimation;
      this.estimation.status = EstimationStatus.QUOTATION_RESPONSE;
      this.loaded = true;
    });
  }

  isInvalid(): boolean {
    return !!this.quotation.quotationValidityDate && dayjs(this.quotation.quotationValidityDate).isBefore(dayjs());
  }

  handleClick(from: any): void {
    this.action.next(new BaryModalEvent(from));
    this.modalRef.hide();
  }

  submit(): void {
    this.action.next(new BaryModalEvent({ submit: true }));
    this.modalRef.hide();
  }
}
